import { HTTPVerbs } from '@nextgen-web-framework/core';
import type { RequestOptions } from '@nextgen-web-framework/core';
import { AprProps } from '../requests/aprApi/types/propTypes';

export const APR_API_VERSION = 'v1';
export const APR_SERVICE_KEY = 'comapras';

export const getAprApiReqObj = ({ aprContainerKey, channel, filter, pageName, slots }: AprProps): RequestOptions => {
  const params: Record<string, string> = {
    containerKey: aprContainerKey,
    channel: channel || 'desktop',
    filter: JSON.stringify(filter || {}),
    pageName,
    slots: slots?.toString() || '5',
  };
  return {
    url: `/${APR_SERVICE_KEY}/${APR_API_VERSION}/recommend`,
    method: HTTPVerbs.GET,
    retries: 0,
    params,
  };
};
